/**
 * User: Joe Forzano
 * Date: August 6th, 2015
 *
 * A wrapper around node-cache that creates a global singleton NodeCache instance for use
 * in both client-side and server-side Javascript.
 */

'use strict';

var NodeCache       = require('node-cache');
var _               = require('underscore');
var assert          = require('bunsen/helpers/assert');

var cache           = new NodeCache({checkperiod: 0});
// NOTE: absense of checkperiod option causes mothra tests to hang
var cacheEnabled    = true;

module.exports = _.extend({

    enableCaching: function () {
        cacheEnabled = true;
    },

    disableCaching: function () {
        cacheEnabled = false;
    },

    get: function (key) {
        if (cacheEnabled) {
            if (_.isArray(key)) {
                return cache.get(key);
            }
            return cache.get([key])[key];
        }
    },

    set: function (key, val) {
        assert(typeof key === 'symbol', 'Key must be of type \'symbol\' to ensure uniqueness');
        if (cacheEnabled) {
            return cache.set(key, val);
        }
    },

    del: function (key) {
        if (_.isArray(key)) {
            return cache.del(key);
        }
        return cache.del([key]);
    },

    keys: function () {
        //Since keys are Symbols, we need to explicitly pull symbols from private _data
        return Object.getOwnPropertySymbols(cache.data);
    },

    flushAll: function () {
        return cache.flushAll();
    }
}, _.chain([
    'flushAll'
]).map(fn => [fn, cache[fn].bind(cache)]).object().value());



// WEBPACK FOOTER //
// ./~/bunsen/helpers/globalCache.es.js